const InputTypesEnum = {
  ActiveClientFeeSelect: 'ActiveClientFeeSelect',
  ActiveContactSelect: 'ActiveContactSelect',
  // As ActiveContactSelect, but the label carries the email too - for pickers where the address matters.
  ActiveContactSelectWithEmail: 'ActiveContactSelectWithEmail',
  ActiveCurrencySelect: 'ActiveCurrencySelect',
  ActiveExternalSalesPartnerSelect: 'ActiveExternalSalesPartnerSelect',
  ActiveGroupMultiChoice: 'ActiveGroupMultiChoice',
  ActiveGroupSelect: 'ActiveGroupSelect',
  ActiveProjectSelect: 'ActiveProjectSelect',
  ActiveServiceSelect: 'activeserviceselect',
  ActiveUserMultiSelect: 'ActiveUserMultiSelect',
  ActiveUserSelect: 'activeuserselect',
  ActiveUserSelectWithGuid: 'activeuserselectwithguid',
  AddressTypeLookupSelect: 'AddressTypeLookupSelect',
  AreaTypeLookupItemSelect: 'AreaTypeLookupItemSelect',
  BilledOfficeSelect: 'BilledOfficeSelect',
  Bool: 'bool',
  BusinessPhone: 'businessphone',
  CallRecordingCostLookupSelect: 'CallRecordingCostLookupSelect',
  CaspianRolesMultiCheck: 'CaspianRolesMultiCheck',
  Checkbox: 'Checkbox',
  ChileBankNameCodeLookupSelect: 'ChileBankNameCodeLookupSelect',
  ChinaBankNameCodeLookupSelect: 'ChinaBankNameCodeLookupSelect',
  ClientForReportSelect: 'ClientForReportSelect',
  ClientLineTypeLookupItemSelect: 'ClientLineTypeLookupItemSelect',
  ClientMultiChoice: 'ClientMultiChoice',
  ClientMultiChoiceAll: 'ClientMultiChoiceAll',
  ClientPaymentRefundMethodSelect: 'ClientPaymentRefundMethodSelect',
  ClientPaymentRefundReasonSelect: 'ClientPaymentRefundReasonSelect',
  ClientPaymentTypeLookupSelect: 'ClientPaymentTypeLookupSelect',
  ClientPaymentTypeLookupTextSelect: 'ClientPaymentTypeLookupTextSelect',
  ClientPaymentTypeLookupTextSelectWithoutPrepayment: 'ClientPaymentTypeLookupTextSelectWithoutPrepayment',
  ClientSelect: 'clientselect',
  ClientStatusLookupItemSelect: 'ClientStatusLookupItemSelect',
  CommissionUserMultiChoice: 'CommissionUserMultiChoice',
  CommissionUserSelect: 'CommissionUserSelect',
  CommonContactMethodLookupItemSelect: 'CommonContactMethodLookupItemSelect',
  CommonCycle: 'CommonCycle',
  CommonDataCaptureMethodLookupItemSelect: 'CommonDataCaptureMethodLookupItemSelect',
  CommonGenderLookupItemSelect: 'CommonGenderLookupItemSelect',
  CommonMaritalStatusLookupItemSelect: 'CommonMaritalStatusLookupItemSelect',
  CommonReferralSourceLookupItemSelect: 'CommonReferralSourceLookupItemSelect',
  ContactMultiChoice: 'ContactMultiChoice',
  ContactSelect: 'contactselect',
  ContactSelectForNewInvoice: 'ContactSelectForNewInvoice',
  CountryCodeMultiChoice: 'CountryCodeMultiChoice',
  CountryMultiChoice: 'CountryMultiChoice',
  CountryNameMultiChoice: 'CountryNameMultiChoice',
  CountryPlanningTable: 'CountryPlanningTable',
  CountrySelect: 'countryselect',
  CountryCodeSelect: 'CountryCodeSelect',
  CountryNameSelect: 'CountryNameSelect',
  CreditMemoReasonLookupItemSelect: 'CreditMemoReasonLookupItemSelect',
  CreditMemoRequestInvoiceSelect: 'CreditMemoRequestInvoiceSelect',
  CreditMemoRequestStatusChange: 'CreditMemoRequestStatusChange',
  CsatCostLookupSelect: 'CsatCostLookupSelect',
  CurrencySelect: 'currencyselect',
  DataFlowMapMultiChoice: 'DataFlowMapMultiChoice',
  Date: 'date',
  DateTime: 'datetime',
  DateWithIndefinite: 'datewithindefinite',
  DepartmentLookupItemSelect: 'departmentlookupitemselect',
  EducationLevelLookupItemSelect: 'EducationLevelLookupItemSelect',
  EmptySpace: 'EmptySpace',
  EmptyYesNoSelect: 'EmptyYesNoSelect',
  EmptyYesNoSelect2: 'EmptyYesNoSelect2',
  EvaluationTypeLookupItemSelect: 'EvaluationTypeLookupItemSelect',
  EvaluatorPaymentMethodLookupItemSelect: 'EvaluatorPaymentMethodLookupItemSelect',
  EvaluatorPaymentStatusLookupItemSelect: 'EvaluatorPaymentStatusLookupItemSelect',
  EvaluatorPaymentTypeLookupItemSelect: 'EvaluatorPaymentTypeLookupItemSelect',
  EvaluatorRotation: 'EvaluatorRotation',
  ExternalSalesPartnerSelect: 'ExternalSalesPartnerSelect',
  FieldworkPeriodApplyTable: 'FieldworkPeriodApplyTable',
  FieldworkPeriodDateTable: 'FieldworkPeriodDateTable',
  FileUploadField: 'FileUploadField',
  FreelancerDepartmentMultiChoice: 'FreelancerDepartmentMultiChoice',
  FreelancerUserManagerSelect: 'FreelancerUserManagerSelect',
  IndustryLookupItemSelect: 'industrylookupitemselect',
  InfoCallout: 'InfoCallout',
  InputWithCheckBox: 'InputWithCheckBox',
  IntToDateInputElement: 'IntToDateInputElement',
  InvoiceBillToContactSelect: 'InvoiceBillToContactSelect',
  InvoiceDaysToPayLookupItemSelect: 'InvoiceDaysToPayLookupItemSelect',
  InvoiceFormTypeLookupItemSelect: 'InvoiceFormTypeLookupItemSelect',
  InvoiceReferenceTemplate: 'InvoiceReferenceTemplate',
  IobLineItemTypeLookupItemSelect: 'IobLineItemTypeLookupItemSelect',
  IvrCostLookupSelect: 'IvrCostLookupSelect',
  JobsNoLongerReadyChoiceSelect: 'JobsNoLongerReadyChoiceSelect',
  LanguageMultiSelect: 'LanguageMultiSelect',
  LeadLookupSelect: 'leadlookupselect',
  LeadSelect: 'LeadSelect',
  Link: 'Link',
  LocationListOptionsLookupItemSelect: 'LocationListOptionsLookupItemSelect',
  LookupMultiChoice: 'LookupMultiChoice',
  LookupTextMultiChoice: 'LookupTextMultiChoice',
  MaxDeliveryAfterShop: 'MaxDeliveryAfterShop',
  MsPartnerSelect: 'mspartnerselect',
  MultiChoice: 'MultiChoice',
  PlatformMultiChoice: 'PlatformMultiChoice',
  MysteryShoppingPlatformPricingLookupSelect: 'MysteryShoppingPlatformPricingLookupSelect',
  Notes: 'Notes',
  Number: 'number',
  Number2: 'number2',
  NumberWithCheckBox: 'NumberWithCheckBox',
  NumberWithoutSteppers: 'numberwithoutsteppers',
  NumberWithTwoDecimalPlaces: 'numberwithtwodecimalsplaces',
  NumberWithTwoDecimalPlaces2: 'numberwithtwodecimalsplaces2',
  OfficialJobTitleLookupItemSelect: 'officialjobtitlelookupitemselect',
  OfficeDetailsGroupSelect: 'OfficeDetailsGroupSelect',
  OfficeForReportMultiSelect: 'OfficeForReportMultiSelect',
  OfficeGroupMultiSelect: 'OfficeGroupMultiSelect',
  OfficeGroupSelect: 'OfficeGroupSelect',
  OfficeMultiSelect: 'officemultiselect',
  OfficeOrGroupForReportMultiSelect: 'OfficeOrGroupForReportMultiSelect',
  OfficeOrGroupMultiSelect: 'OfficeOrGroupMultiSelect',
  OfficeOrGroupSelect: 'OfficeOrGroupSelect',
  OfficeSelect: 'officeselect',
  OnOff: 'OnOff',
  OpportunityMultiChoice: 'OpportunityMultiChoice',
  OpportunitySelect: 'OpportunitySelect',
  OpportunityReasonLost: 'OpportunityReasonLost',
  OpportunityStatusChange: 'OpportunityStatusChange',
  OpportunityTypeLookupItemSelect: 'OpportunityTypeLookupItemSelect',
  OtherValidationRequirementLookupItemSelect: 'OtherValidationRequirement',
  OutsourcedActivityOfficeSelect: 'OutsourcedActivityOfficeSelect',
  OutsourcedUserSelect: 'OutsourcedUserSelect',
  PaymentOfficeSelect: 'paymentofficeselect',
  PaymentRequestStatusChangeSelect: 'PaymentRequestStatusChangeSelect',
  PhoneNumber: 'phonenumber',
  PillSelect: 'PillSelect',
  PlaceHolder: 'placeHolder',
  PrimaryFreelancerUserSelect: 'PrimaryFreelancerUserSelect',
  PricingStatusChange: 'PricingStatusChange',
  PricingStatusLookupItemSelect: 'PricingStatusLookupItemSelect',
  ProjectForReportSelect: 'ProjectForReportSelect',
  ProjectManagerSelect: 'projectmanagerselect',
  ProjectOpportunitySelect: 'ProjectOpportunitySelect',
  ProjectSelect: 'ProjectSelect',
  ProjectServiceSelect: 'ProjectServiceSelect',
  ReportLanguageLookupItemSelect: 'ReportLanguageLookupItemSelect',
  Select: 'select',
  Select2: 'select2',
  SelectAddressWithInformationByEntityType: 'SelectAddressWithInformationByEntityType',
  ServiceCountryMultiSelect: 'ServiceCountryMultiSelect',
  ServiceFeeTypeLookupSelect: 'ServiceFeeTypeLookupSelect',
  ServiceMultiChoice: 'ServiceMultiChoice',
  ServiceSelect: 'serviceselect',
  ServiceType: 'ServiceType',
  SingleCheckBox: 'SingleCheckBox',
  SourceSelect: 'sourceselect',
  SourceLookupItemSelect: 'sourcelookupitemselect',
  SurveyMultiChoice: 'SurveyMultiChoice',
  SurveySelect: 'surveyselect',
  Text: 'text',
  Text2: 'text2',
  TextBox: 'textbox',
  TextBox2: 'textbox2',
  TextBoxReadOnly: 'TextBoxReadOnly',
  // A comma-separated list of values, with an "Import list" box to paste cells copied from Excel into.
  TextList: 'TextList',
  TextReadOnly: 'textreadonly',
  ThirdPartySourceSelect: 'ThirdPartySourceSelect',
  ThirdPartySourceTpClientLinkSelect: 'ThirdPartySourceTpClientLinkSelect',
  ThirdPartySourceMultiChoice: 'ThirdPartySourceMultiChoice',
  ThirdPartySourceEvaluatorMultiChoice: 'ThirdPartySourceEvaluatorMultiChoice',
  ThirdPartySourceTpJobMultiChoice: 'ThirdPartySourceTpJobMultiChoice',
  TargetRate: 'TargetRate',
  TierLookupItemSelect: 'tierlookupitemselect',
  Time: 'time',
  TimeZone: 'LookupItemSelect',
  TimesheetUserListSelect: 'TimesheetUserListSelect',
  TpCreditMemoReasonLookupItemSelect: 'TpCreditMemoReasonLookupItemSelect',
  TpCreditMemoTpClientInvoiceSelect: 'TpCreditMemoTpClientInvoiceSelect',
  TpEvaluatorSelect: 'TpEvaluatorSelect',
  TpJobThirdPartyStatusMultiSelect: 'TpJobThirdPartyStatusMultiSelect',
  TpJobStatusMultiSelect: 'TpJobStatusMultiSelect',
  TpPaymentRequestStatusChangeSelect: 'TpPaymentRequestStatusChangeSelect',
  TpSurveyMultiChoice: 'TpSurveyMultiChoice',
  TpSurveySelect: 'TpSurveySelect',
  TpSurveyByClientAndInstanceSelect: 'TpSurveyByClientAndInstanceSelect',
  TpRunSelect: 'TpRunSelect',
  TpWaveSelect: 'TpWaveSelect',
  UserMultiSelect: 'UserMultiSelect',
  UserSelect: 'userselect',
  WaveSelect: 'WaveSelect',
  LookupItemMiscMultiChoice: 'LookupItemMiscMultiChoice',
  // Predefined evaluator-id lists of the approved-payments export (LookupItemMiscMultiChoice
  // variants bound to the 'Approved Assignment Payment Report' lookup's TP / Caspian item).
  PredefinedTpEvaluatorsMultiChoice: 'PredefinedTpEvaluatorsMultiChoice',
  PredefinedEvaluatorsMultiChoice: 'PredefinedEvaluatorsMultiChoice',
  // A searchable single-select of long-text options (e.g. survey questions / answer options):
  // truncated option labels + full text of the selection shown in a read-only textarea, with an
  // empty option for NULL. Options are passed via the field's `options` (each: { value, text, secondaryId? }).
  SourceQuestionSelect: 'SourceQuestionSelect',
  // Language dropdown whose value is a locale tag (en_US, de_DE, ...), not a language id
  ApolloLanguageLocaleSelect: 'ApolloLanguageLocaleSelect',
};

export default InputTypesEnum;
